var map = {
	"./2022-heighlight-card.jpg": 8698,
	"./business-strategy.jpg": 8904,
	"./environment.jpg": 1311,
	"./img-1.jpg": 1590,
	"./img-2.jpg": 9212,
	"./img-3.jpg": 8745,
	"./img-4.jpg": 995,
	"./img-5.jpg": 3984,
	"./our-lnaugural-esg-report-card.jpg": 7781,
	"./overarching-card.jpg": 6829,
	"./project-future-card.jpg": 831,
	"./resource-1.jpg": 674,
	"./resource-2.jpg": 8350,
	"./social-imact.jpg": 292,
	"./social.jpg": 629,
	"./solar-panels.jpg": 8195,
	"./statements-1.jpg": 3486,
	"./statements-2.jpg": 8110,
	"./sustainable-financing-card-one.jpg": 3037,
	"./sustainable-projects.jpg": 202,
	"./sustanable.jpg": 2728,
	"./transition-to-net-zero-card-two.jpg": 978,
	"./transition-to-net-zero-card.jpg": 4952,
	"./vision.jpg": 145,
	"./water-2.jpg": 6839,
	"./water-image.jpg": 1195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2800;